<template xmlns="http://www.w3.org/1999/html">
  <div class="Consultation_appointment">
    <el-row  v-if="this.Global.pdroleid(1058)||this.Global.pdroleid(1075)" :gutter="20" class="Consultation_appointment_top">
      <el-col :span="7">
        <div class="grid-content">
          <h2>个人信息<info>可约次数：{{myConsultInfo.Rest}}</info></h2>
          <img src="../../assets/20230707104558.png" alt="">
          <h6>请先完善个人信息</h6>
          <span>{{ BasicInfo.BasicAnswerStatus == 1 ? "已填写" : "未完善" }}</span>
            <!-- <span>{{ data.BasicInfo.BasicAnswerStatus == 1 ? "已完善" : "未完善" }}</span> -->
          <div @click="fillInformation()">填写</div>
          <!-- this.$router.push({path: "/measurement/PaperTest",query: { PaperID: this.checkList[0], PublishID: "0", type: 4 }}); -->
        </div>
      </el-col>

      <el-col :span="7">
        <div class="grid-content">
          <h2>咨询问卷</h2>
          <img src="../../assets/20230707104625.png" alt="">
          <h6>请先填写咨询问卷</h6>
           <span>{{ ConsultInfo.ConsultAnswerStatus == 1 ? "已填写" : "未完善" }}</span>
          <div @click="drawerQuestionnaire = true">填写</div>
        </div>
      </el-col>

      <el-col :span="10">
        <div class="grid-content2">
          <h2>心理评估</h2>
          <img src="../../assets/20230707104634.png" alt="">
          <div class="evaluation">
            <div class="questionnaire"  style="border-bottom: 1px dashed #ddd; " @click="evaluationScale('SAS')">
              <div class="describe">
                <h6>SAS焦虑自评量表</h6>
                <span v-if="ConsultInfo.SASResult != ''" style="color: #888">测评日期：{{ConsultInfo.SASTime}}</span>
<!--                <span v-else-if="ConsultInfo.SASResult == ''">已失效，请重新测试</span>-->
              </div>
              <div v-if="ConsultInfo.SASResult != ''" class="score">{{ConsultInfo.SASResult}}</div>
              <div v-else-if="ConsultInfo.SASResult == ''" class="button" @click="evaluationScale('SAS')">填写</div>
            </div>
            <div class="questionnaire" style="padding-top: 5px"  @click="evaluationScale('SDS')">
              <div class="describe">

                <h6>SDS抑郁自评量表</h6>

                <span v-if="ConsultInfo.SDSResult != ''" style="color: #888">测评日期：{{ConsultInfo.SDSTime}}</span>

<!--            <span v-else-if="ConsultInfo.SDSResult == ''">已失效，请重新测试</span>-->

              </div>
              <div v-if="ConsultInfo.SDSResult != ''" class="score">{{ConsultInfo.SDSResult}}</div>
              <div v-else-if="ConsultInfo.SDSResult == ''" class="button" @click="evaluationScale('SDS')">填写</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="Consultation_appointment_buttom">
      <el-col :span="7">
        <div class="grid-content bg-purple">
          <h2 style="padding-top: 10px;padding-bottom: 20px;margin-left: 10px;font-size: 16px;">{{ (this.Global.pdroleid(1058) ||this.Global.pdroleid(1075))?"咨询筛选":"咨询预约"}}</h2>
          <div class="train" v-if="!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))">
            <el-button type="primary" @click="gotoAddSchList">预约直通车</el-button>
            <div class="trainFont">预约直通车可直接排班的同时，帮学生预约</div>
          </div>
          <el-form class="form1" ref="form"  :model="form" label-width="80px">
            <el-form-item v-if="!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))" label="学生：">
              <el-select filterable remote reserve-keyword placeholder="姓名、手机或账号查找"
                         :remote-method="getVsitorNameList" v-model="form.UserID" @change="selectVsitorName()">
                <el-option v-for="item in VsitorNameList" :key="item.UserID" :label="item.UserName+item.UserID" :value="item.UserID"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="咨询方式：">
              <el-select v-model="form.ConsultType" placeholder="请选择咨询方式" @change="getSchedul">
                <el-option label="全部" value=""></el-option>
                <el-option label="面对面咨询" value="0"></el-option>
                <el-option label="远程视频" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="校区：">
              <el-select v-model="form.Campus" placeholder="请选择校区"  @change="getSchedul">
                <el-option label="全部" value=""></el-option>
                <el-option
                        v-for="item in value16"
                        :key="item.dicKey"
                        :label="item.cDicValue"
                        :value="item.dicKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="咨询师：">
              <el-select v-model="form.Counselor" placeholder="请选择咨询师"  @change="getSchedul">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item, itemIndex) in CounselorList"  :key="itemIndex" :label="item.RealName" :value="item.UserID"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="咨询日期：">
<!--              <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" ></el-date-picker>-->
              <el-date-picker  :disabled="this.form.UserID=='' && !(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))"
                        v-model="selDate"
                        align="right"
                        type="date"
                        placeholder="请选择日期"
                        :picker-options="pickerOptions"  @change="getSchedul">
              </el-date-picker>
            </el-form-item>
            <div class="obtain">
<!--              <el-button type="primary" @click="getSchedul">筛选排班</el-button>-->
              <el-button type="primary" @click="reset">重置条件</el-button>
            </div>

            <div  v-if="DayInfo.length != 0" class="blockDate">
              <div class="date">咨询时间：</div>
              <div>
                <el-radio-group v-model="radio3" size="medium">
<!--                  <el-radio label="1" border  class="myradio">09:00 - 10:00</el-radio>-->
<!--                  <el-radio label="2" border  class="myradio">10:00 - 11:00</el-radio>-->
<!--                  <el-radio label="3" border  class="myradio">10:00 - 11:00</el-radio>-->
                  <el-radio v-for="(item, itemIndex) in DayInfo"  :key="itemIndex" :label="itemIndex" border  class="myradio">{{item.StartTime.substring(0,5)}} - {{ ('0'+(parseInt(item.StartTime.split(':')[0])+1)).substr(-2)+':'+item.StartTime.split(':')[1]}}</el-radio>
                </el-radio-group>
              </div>
            </div>
            <!-- <el-form-item>
              <el-button type="primary" @click="onSubmit">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item> -->
          </el-form>
        </div>
      </el-col>

      <el-col :span="17">
        <div v-if="DayInfo.length == 0" class="noContent">
          {{ (this.Global.pdroleid(1058)||this.Global.pdroleid(1075)) ?"没有找到您可预约的咨询师，您可能没有填写相关资料或测评，也可能筛选条件太多！":"请选择左侧的条件筛选咨询师排班后，才可帮选择的学生预约咨询！"}}
        </div>
        <div v-if="DayInfo.length != 0" class="grid-content bg-purple">
          <h2 style="padding-top: 10px;margin-left: 10px;font-size: 16px;">咨询师列表</h2>
          <ul class="zxslist">
<!--            <li  v-for="(item, itemIndex) in CounselorInfoList" :key="itemIndex">-->
<!--              <img v-if="item.ZHeadPhotoURL!=''" :src="item.ZHeadPhotoURL" :alt="item.RealName">-->
<!--              <img v-if="item.ZHeadPhotoURL==''" src="../../assets/bgc1227191745.png" :alt="item.RealName">-->
<!--              <h3>{{item.RealName}}</h3>-->
<!--&lt;!&ndash;              <p class="zxslist_p">深度辅导</p>&ndash;&gt;-->
<!--              <p class="zxslist_p" @click="getConsultantInfo(item)">去预约</p>-->
<!--              <ul>-->
<!--                <li style="border: 1px solid rgba(21, 191, 109, 1);color: rgba(21, 191, 109, 1);">可约</li>-->
<!--                <li style="border: 1px solid rgba(242, 75, 78, 1);color: rgba(242, 75, 78, 1);">候补</li>-->
<!--                <li style="border: 1px solid rgba(255, 149, 43, 1);color: rgba(255, 149, 43, 1);">面约</li>-->
<!--                <li style="border: 1px solid rgba(172, 51, 193, 1);color: rgba(172, 51, 193, 1);">远程</li>-->
<!--              </ul>-->
<!--              <i class="el-icon-location-outline"></i>-->
<!--              <span>{{item.Campus}}</span>-->
<!--              <p class="zxslist_p2">-->
<!--                <span style="color: rgba(0, 136, 255, 1);">个人简介:</span>-->
<!--                {{item.IndividualResume}}-->
<!--              </p>-->
<!--            </li>-->
            <li v-for="(item, itemIndex) in DayInfo[radio3].TimeScheduls" :key="itemIndex">
              <img :src="item.ZHeadPhotoURL">
<!--              <img v-if="Consultant.ZHeadPhotoURL.indexOf('null')!=-1" src="../../assets/bgc1227191745.png" :alt="item.RealName">-->
              <h3>{{item.RealName}}</h3>
              <!--              <p class="zxslist_p">深度辅导</p>-->

              <ul>
                <li v-if="item.ScheduleFlag && !item.CandidateLabel && !item.ScheduleLabel" style="border: 1px solid rgba(21, 191, 109, 1);color: rgba(21, 191, 109, 1);">可预约</li>
                <li v-if="item.CandidateFlag && !item.CandidateLabel && !item.ScheduleLabel" style="border: 1px solid rgba(242, 75, 78, 1);color: rgba(242, 75, 78, 1);">可候补</li>
                <li v-if="item.ScheduleLabel" style="border: 1px solid rgba(242, 75, 78, 1);color: rgba(242, 75, 78, 1);">已预约</li>
                <li v-if="item.CandidateLabel" style="border: 1px solid rgba(242, 75, 78, 1);color: rgba(242, 75, 78, 1);">已候补</li>
                <li v-if="item.ConsultType.includes('0')" style="border: 1px solid rgba(255, 149, 43, 1);color: rgba(255, 149, 43, 1);">面约</li>
                <li v-if="item.ConsultType.includes('1')" style="border: 1px solid rgba(172, 51, 193, 1);color: rgba(172, 51, 193, 1);">远程</li>
              </ul>
              <i class="el-icon-location-outline"></i>
              <span>{{item.Address}}</span>
              <p v-if="item.ScheduleFlag && !item.CandidateLabel && !item.ScheduleLabel" :class="IsCanAppoint == 0 ? 'zxslist_p':'myConsult'" @click="getConsultantInfo(item)">去预约</p>
              <p v-if="item.CandidateFlag && !item.CandidateLabel && !item.ScheduleLabel" :class="IsCanAppoint == 0 ? 'zxslist_p':'myConsult'" @click="getConsultantInfo(item)">去候补</p>
              <p v-if="item.CandidateLabel" class="myConsult" @click="toMyConsult()">我的候补</p>
              <p v-if="item.ScheduleLabel" class="myConsult" @click="toMyConsult()">我的咨询</p>
<!--              <p class="zxslist_p2">-->
<!--                <span style="color: rgba(0, 136, 255, 1);">个人简介:</span>-->
<!--                {{item.IndividualResume}}-->
<!--              </p>-->
            </li>

<!--            <li>-->
<!--              <img src="../../assets/bgc1227191745.png" alt="">-->
<!--              <h3>付老师</h3>-->
<!--              <p class="zxslist_p">深度辅导</p>-->
<!--              <ul>-->
<!--                <li style="border: 1px solid rgba(21, 191, 109, 1);color: rgba(21, 191, 109, 1);">可约</li>-->
<!--                <li style="border: 1px solid rgba(242, 75, 78, 1);color: rgba(242, 75, 78, 1);">候补</li>-->
<!--                <li style="border: 1px solid rgba(255, 149, 43, 1);color: rgba(255, 149, 43, 1);">面约</li>-->
<!--                <li style="border: 1px solid rgba(172, 51, 193, 1);color: rgba(172, 51, 193, 1);">远程</li>-->
<!--              </ul>-->
<!--              <i class="el-icon-location-outline"></i>-->
<!--              <span>北京市朝阳路校区</span>-->
<!--              <p class="zxslist_p2">-->
<!--                <span style="color: rgba(0, 136, 255, 1);">个人简介:</span> -->
<!--                外交关系，个人探索与成长，人际交往与亲密关系；中国大学心理中心咨询师，美国帕洛阿尔托大学心理咨询师。具有15年的心理咨询服务从业经美国帕洛阿尔托大学咨询师...外交关系，个人探索与成长，人际交往与亲密关系；中国大学心理中心咨询师，美国帕洛阿尔托大学心理咨询师。具有15年的心理咨询服务从业经美国帕洛阿尔托大学咨询师.-->
<!--              </p>-->
<!--            </li>-->

          </ul>
        </div>
      </el-col>
    </el-row>

    <el-dialog v-if="this.Global.pdroleid(1058)||this.Global.pdroleid(1075)" title="预约咨询流程" :visible.sync="dialogVisible" width="50%" :before-close="no_look">
      <el-steps align-center>
        <el-step title="第一步 完善信息" description="预约前需要填写个人信息、咨询问卷、心理评估"></el-step>
        <el-step title="第二步 咨询筛选" description="根据自己的情况筛选出最合适的咨询师"></el-step>
        <el-step title="第三步 预约确认" description="选中要预约咨询师，并确认预约"></el-step>
      </el-steps>

      <div style="padding-top: 40px;padding-bottom: 40px;text-align: center;">
        <el-button type="primary" @click="no_look()">不再显示</el-button>
        <el-button type="primary" @click="no_look()">开始预约</el-button>
      </div>

    </el-dialog>

    <el-dialog class="consentFormDialog" v-if="(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))" title="知情同意书" :visible.sync="ConsentFormVisible" width="80%" :show-close="false" :close-on-click-modal="false">
      <div class="consentForm">
        以下是关于心理咨询的一些基本约定，请仔细阅读并在下面签字表明你清楚理解和接受相关规定，并能为自己的行为负责。</br>
        1.为了充分尊重和保护求助者以及咨询师的权益，特制定本《心理咨询知情同意书》。</br>
        2.求助者登入在线咨询平台寻求心理咨询服务是自愿行为，咨询过程中应自愿提供真实信息，对于提供虚假或失真信息者，其咨询结果及其它相应后果由求助者本人负责。</br>
        3.心理中心和心理咨询师对求助者提供的信息将严格保密，如果出现下述情况：</br>
        (1)经评估认为求助者有自我伤害或伤害他人的倾向；</br>
        (2)经评估认为求助者有可能出现幻觉、妄想等状态；</br>
        (3）求助者的情况涉及到疫情的重要信息和疫情的传播；</br>
        (4）求助者的情况涉及法律责任或国家司法机关要求提供；</br>
        可突破保密原则，向求助者的紧急联系人及有关部门通告。</br>
        4.每次在线心理咨询时间约为50分钟。请按时出席预约的咨询。预约开始后10分钟，若求助者仍未登陆，咨询师有权退出并取消此次咨询服务。</br>
        5.求助者有义务主动提供专业医疗机构做出的精神疾病相关诊断，不能隐瞒精神病史、重大躯体疾病及严重传染性疾病。求助者有义务按照心理咨询师的要求到专科医疗机构进行精神障碍诊断。</br>
        6.咨询师因专业工作需要对咨询的案例接受专业督导，过程中会隐去求助者的隐私信息，为求助者保密。</br>
        7.咨询开始前24小时内取消咨询，本学期咨询可用次数将被扣除一次。</br>
      </div>

      <div class="agreeInfoBox">
        <el-checkbox v-model="checked"></el-checkbox><span class="agreeInfo">我已经认真阅读并理解了上述信息。我同意参加心理咨询，与心理咨询师建立平等的咨访关系，在咨询过程中履行相应的权利和义务。我承诺在基本个人信息、咨询诉求和咨询登记表中填写的信息属实，并承担如果信息不实所带来的一切后果。</span> </br>
        <div class="buttonBox"> <el-button type="primary" @click="acceptForm()">同意并提交</el-button> </div>
      </div>


    </el-dialog>

    <el-drawer class="Personal_info"  :visible.sync="drawer" :with-header="false">
      <h4>个人信息</h4>
      <h5>
        <i style="color: red;">*</i>
        基本信息
      </h5>

      <el-form class="form2 form4" ref="form2" :model="BasicInfo" label-width="80px">

        <el-form-item label="姓名" >
          <el-input v-model="BasicInfo.RealName" placeholder="请输入姓名" disabled></el-input>
        </el-form-item>

        <el-form-item label="学号" >
          <el-input v-model="BasicInfo.UserID" placeholder="请输入学号" disabled></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="BasicInfo.Sex" disabled>
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="出生日期">
          <el-date-picker  v-model="BasicInfo.Birthday" type="date" placeholder="选择日期" disabled></el-date-picker>
        </el-form-item>

        <el-form-item label="联系电话"> 
          <el-input v-model="BasicInfo.Phone"  placeholder="请输入联系电话" disabled></el-input>
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input v-model="BasicInfo.IDCard"  placeholder="请输入身份证号" disabled></el-input>
        </el-form-item>

        <h5>
          <i style="color: red; margin-left: -20px !important;">*</i>
          所在单位
        </h5>

        <el-form-item style="padding-top: 20px;" label="培养单位" prop="DeptID">
          <el-input v-model="DeptName"  placeholder="暂无培养单位" disabled></el-input>
        </el-form-item>

        <el-form-item label="管理单位" prop="DeptID">
          <el-input v-model="TrainName"  placeholder="暂无培养单位" disabled></el-input>
        </el-form-item>

        <el-form-item label="集中教学单位" prop="DeptID">
          <el-input v-model="TeachName"  placeholder="暂无集中教学单位" disabled></el-input>
        </el-form-item>

        <h5 style="margin-left: 10px !important;">
          其他信息
        </h5>

<!--        <el-form-item style="padding-top: 20px;" label="婚姻状态">-->
<!--          <el-input v-model="BasicInfo.MarriageState"  placeholder="暂无记录" disabled></el-input>-->
<!--        </el-form-item>-->

        <el-form-item style="padding-top: 20px;" label="婚姻状态">
          <el-select v-model="BasicInfo.MarriageState" placeholder="暂无记录" disabled>
            <el-option v-for="item in value7" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮箱">
          <el-input v-model="BasicInfo.Email"  placeholder="暂无记录" disabled></el-input>
        </el-form-item>

<!--        <el-form-item label="籍贯">-->
<!--          <el-input v-model="BasicInfo.NativePlace"  placeholder="暂无记录" disabled></el-input>-->
<!--        </el-form-item>-->

<!--        -->

<!--        <el-form-item label="民族">-->
<!--          <el-input v-model="BasicInfo.Nation"  placeholder="暂无记录" disabled></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="籍贯">
          <el-select v-model="BasicInfo.NativePlace" placeholder="暂无记录" disabled>
            <el-option v-for="item in indexval" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族">
          <el-select v-model="BasicInfo.Nation" placeholder="暂无记录" disabled>
            <el-option v-for="item in indexval2" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="现住址">
          <el-input v-model="BasicInfo.Address" placeholder="暂无记录" disabled></el-input>
        </el-form-item>

        <el-form-item label="宗教信仰">
          <el-input v-model="BasicInfo.ReligiousBelief" placeholder="暂无记录" disabled></el-input>
        </el-form-item>

        <h5 style="margin-left: 10px !important;">
          紧急联系人信息
        </h5>
        <el-form-item style="padding-top: 20px;" label="姓名">
          <el-input v-model="BasicInfo.EmergencyName" placeholder="暂无记录" disabled></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="BasicInfo.EmergencyPhone" placeholder="暂无记录" disabled></el-input>
        </el-form-item>
        <el-form-item label="与本人关系">
          <el-input v-model="BasicInfo.EmergencyRelation.cDicValue" placeholder="暂无记录" disabled></el-input>
        </el-form-item>
       
        <el-form-item class="formButton">
          <el-button  @click="drawer = false">取消</el-button>
          <el-button type="primary" @click="getFamily">填写家庭信息</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer class="Personal_info family_info"  :visible.sync="drawerFamily" :with-header="false">
      <h4>家庭信息</h4>
      <h5>
        <i style="color: red;">*</i>
        家庭情况调查表
      </h5>

      <el-form class="form2" ref="form2" :model="BasicInfo" label-width="80px">
        <h6 class="familyTitle">
          1、是否独生子女
        </h6>
        <el-radio-group v-model="BasicInfo.OnlySon" class="radioStyle">
          <el-radio label=1>是</el-radio>
          <el-radio label=0>否</el-radio>
        </el-radio-group>
        <el-input class="order" maxlength="2" v-if="BasicInfo.OnlySon==0" v-model="BasicInfo.BirthOrder" placeholder="兄弟排行第几？"></el-input>

        <h6 class="familyTitle">
          2、家庭所在地类型
        </h6>
        <el-radio-group v-model="BasicInfo.HomeType" class="radioStyle">
          <el-radio label=0>城市</el-radio>
          <el-radio label=1>乡镇</el-radio>
          <el-radio label=2>农村</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          3、是否享受我校贫困生相关政策及补助
        </h6>
        <el-radio-group v-model="BasicInfo.IsSubsidy" class="radioStyle">
          <el-radio label=1>是</el-radio>
          <el-radio label=0>否</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          4、父亲文化程度
        </h6>
        <el-radio-group v-model="BasicInfo.FatherDegree" class="radioStyle">
          <el-radio label=0>研究生以上</el-radio>
          <el-radio label=1>大学/大专</el-radio>
          <el-radio label=2>高中/中专/中技</el-radio>
          <el-radio label=3>初中</el-radio>
          <el-radio label=4>小学及以下</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          5、母亲文化程度
        </h6>
        <el-radio-group v-model="BasicInfo.MatherDegree" class="radioStyle">
          <el-radio label=0>研究生以上</el-radio>
          <el-radio label=1>大学/大专</el-radio>
          <el-radio label=2>高中/中专/中技</el-radio>
          <el-radio label=3>初中</el-radio>
          <el-radio label=4>小学及以下</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          6、目前家庭情况
        </h6>
        <el-radio-group v-model="BasicInfo.FamilyStatus" class="radioStyle">
          <el-radio label=0>原生家庭</el-radio>
          <el-radio label=1>丧亲</el-radio>
          <el-radio label=2>离异</el-radio>
          <el-radio label=3>再组家庭</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          7、你如何评价自己家庭的经济状况(1为非常困难，5为非常富裕)
        </h6>
        <el-radio-group v-model="BasicInfo.EconStatus" class="radioStyle">
          <el-radio label=1>1分</el-radio>
          <el-radio label=2>2分</el-radio>
          <el-radio label=3>3分</el-radio>
          <el-radio label=4>4分</el-radio>
          <el-radio label=5>5分</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          8、对家庭的喜欢程度(1为非常厌恶，5为非常喜欢)
        </h6>
        <el-radio-group v-model="BasicInfo.LikeLevel" class="radioStyle">
          <el-radio label=1>1分</el-radio>
          <el-radio label=2>2分</el-radio>
          <el-radio label=3>3分</el-radio>
          <el-radio label=4>4分</el-radio>
          <el-radio label=5>5分</el-radio>
        </el-radio-group>

        <h6 class="familyTitle">
          9、家庭成员（父系家族及母系家族各三代）有无精神病史
        </h6>
        <el-radio-group v-model="BasicInfo.MentalHistory" class="radioStyle">
          <el-radio label=0>无</el-radio>
          <el-radio label=1>有，抑郁症</el-radio>
          <el-radio label=2>有，焦虑症</el-radio>
          <el-radio label=3>有，强迫症</el-radio>
          <el-radio label=4>有，其他精神障碍</el-radio>
<!--          <el-radio label=4>其他<el-input v-model="BasicInfo.MentalHistory" placeholder="暂无记录" :disabled="BasicInfo.MentalHistory!=4"></el-input></el-radio>-->
        </el-radio-group>
        <el-input v-if="BasicInfo.MentalHistory==4"
                  maxlength="100"
                  type="textarea"
                  :rows="4"
                  placeholder="请填写家庭成员其他精神障碍明细内容"
                  v-model="BasicInfo.MentalHistoryDetail">
        </el-input>

        <el-form-item class="formButton">
          <el-button @click="drawerFamily = false">取消</el-button>
          <el-button type="primary" @click="submitBasicInfo">完成</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer class="Personal_info family_info"  :visible.sync="drawerQuestionnaire" :with-header="false">
      <h4>咨询问卷</h4>
      <el-form class="form2" ref="form2" :model="BasicInfo" label-width="80px">


<!--        <el-form-item label="咨询方式" class="oneLine">-->
<!--          <el-radio-group v-model="ConsultInfo.ConsultType">-->
<!--            <el-radio label=0>面对面咨询</el-radio>-->
<!--            <el-radio label=1>远程视频</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->

        <el-form-item label="咨询主题" >
          <el-select v-model="subject" collapse-tags multiple placeholder="请选择咨询主题">
            <el-option
                    v-for="item in value25"
                    :key="item.dicKey"
                    :label="item.cDicValue"
                    :value="item.dicKey">
            </el-option>
          </el-select>
       </el-form-item>
<!--        <h6 v-if="subject.indexOf('198')>0" class="familyTitle">-->
<!--          你需要咨询的其他主题:-->
<!--        </h6>-->
        <el-input v-if="subject.indexOf('198')>0" style="margin-bottom: 20px"
                type="textarea"
                :rows="4"
                placeholder="请填写其他咨询主题"
                v-model="ConsultInfo.OtherConsultTheme">
        </el-input>
        <h6 class="familyTitle">
          你想要咨询的主要问题是？
        </h6>
        <el-input
                maxlength="100"
                type="textarea"
                :rows="4"
                placeholder="这一问题对你产生哪些影响，可以从问题程度、频率、持续时间等进行描述!"
                v-model="ConsultInfo.ConsultCntIntroduce">
        </el-input>



        <h5>
          <i style="color: red; margin-left: -20px !important;">*</i>
          咨询调研
        </h5>
        <h6 class="familyTitle" style="padding-top: 20px;">
          1、你是否有过自杀、自伤以及伤害他人的想法或经历？
        </h6>
        <el-radio-group v-model="ConsultInfo.IsHurt" class="oneLine2">
          <el-radio label=1>是</el-radio>
          <el-radio label=0>否</el-radio>
        </el-radio-group>
        <el-input v-if="ConsultInfo.IsHurt==1"
                  maxlength="1000"
                type="textarea"
                :rows="4"
                placeholder="请填写明确具体的想法及相关经历的内容"
                v-model="ConsultInfo.HurtDetail">
        </el-input>
        <h6 class="familyTitle">
          2、你是否有攻击他人的行为？
        </h6>
        <el-radio-group v-model="ConsultInfo.IsAttack" class="oneLine2">
          <el-radio label=1>是</el-radio>
          <el-radio label=0>否</el-radio>
        </el-radio-group>
        <el-input v-if="ConsultInfo.IsAttack==1"
                  maxlength="1000"
                  type="textarea"
                  :rows="4"
                  placeholder="请填写行为内容"
                  v-model="ConsultInfo.AttackDetail">
        </el-input>
        <h6 class="familyTitle">
          3、你是否曾经在精神科就医？
        </h6>
        <el-radio-group v-model="ConsultInfo.IsSpiritCure" class="oneLine2">
          <el-radio label=1>是</el-radio>
          <el-radio label=0>否</el-radio>
        </el-radio-group>
        <el-input v-if="ConsultInfo.IsSpiritCure==1"
                  maxlength="1000"
                  type="textarea"
                  :rows="4"
                  placeholder="请填写就医诊断结果"
                  v-model="ConsultInfo.SpiritCureDetail">
        </el-input>

        <el-select v-if="ConsultInfo.IsSpiritCure==1" style="margin-top: 15px" v-model="drugs" collapse-tags multiple placeholder="请选择服用过哪些药物">
          <el-option
                  v-for="item in value29"
                  :key="item.dicKey"
                  :label="item.cDicValue"
                  :value="item.dicKey">
          </el-option>
        </el-select>
        <el-form-item class="formButton">
          <el-button @click="drawerQuestionnaire = false">取消</el-button>
          <el-button type="primary" @click="submitConsultInfo">完成</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer class="appointmentSubmission"  :visible.sync="drawerConsultant" :with-header="false">
      <h4>预约确认</h4>
      <div class="consultantIntroduction">
        <img :src="Consultant.ZHeadPhotoURL">
<!--        <img v-if="Consultant.ZHeadPhotoURL.indexOf('null')!=-1" src="../../assets/bgc1227191745.png" :alt="Consultant.RealName">-->
        <h3>{{Consultant.RealName}}<span v-if="SelConsultant.roleID == 1061" class="rank">深度辅导</span></h3>
        <i class="el-icon-location-outline"></i>
        <span class="position">{{Consultant.ConsultAddress}}</span>
        <p class="introduction">
          <span style="color: rgba(0, 136, 255, 1);">个人简介:</span>
          {{Consultant.ZSelfIntroduction}}
        </p>
        <p class="introduction">
          <span style="color: rgba(0, 136, 255, 1);">擅长领域:</span>
          {{Consultant.Expertise}}
        </p>
      </div>
      <h5>
        <i style="color: red;">*</i>
        预约信息
      </h5>

      <el-form class="form3" ref="form3" :model="form3" label-width="80px">
        <el-form-item label="咨询日期" >
          {{Consultant.SchedulDate}}
        </el-form-item>

        <el-form-item label="咨询时段" >
          {{SelConsultant.StartTime}} - {{SelConsultant.FinishTime}}
        </el-form-item>

        <el-form-item label="咨询方式">
          <el-radio-group v-model="selConsultType" v-if="(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))">
            <el-radio v-if="SelConsultant.ConsultType0" label=0>面对面咨询</el-radio>
            <el-radio v-if="SelConsultant.ConsultType1" label=1>远程视频</el-radio>
          </el-radio-group>
          <el-radio-group v-model="selConsultTypeAdmin"  v-if="!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))">
            <el-radio v-if="SelConsultant.ConsultType0" label="0">面对面咨询</el-radio>
            <el-radio v-if="SelConsultant.ConsultType1" label="1">远程视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="咨询地点">
          {{Consultant.ConsultAddress}}
          <p class="attention">注:选择面对面时才需前往</p>
        </el-form-item>

        <el-form-item class="formButton">
          <el-button @click="drawerConsultant = false">取消</el-button>
          <el-button v-if="SelConsultant.ScheduleFlag && !SelConsultant.CandidateLabel && !SelConsultant.ScheduleLabel" type="primary" @click="consultSubmit">确认预约</el-button>
          <el-button v-if="SelConsultant.CandidateFlag && !SelConsultant.CandidateLabel && !SelConsultant.ScheduleLabel" type="primary" @click="consultSubmit">确认候补</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

  </div>
</template>
<script>
  export default {
    data() {
    return {
      checked: false,
      RoleID:sessionStorage.getItem('RoleID'),
      pickerOptions: '',
      radio3: 0,
      data: [],
      data2: [],
      data3: [],
      option: [],

      dialogVisible: localStorage.getItem('Conversation') == 1 ? false : true,
      ConsentFormVisible:localStorage.getItem('ConsentForm') == 1 ? true : false,
      data1: [],//咨询评估首页数据
      BasicInfo: {
        EmergencyRelation:{cDicValue:''}
      },
      DeptName:this.Global.DeptName,
      TeachName:this.Global.TeachName,
      TrainName:this.Global.TrainName,
      ConsultInfo: {

      },
      SelConsultant:{

      },
      Consultant:{

      },
      CounselorInfoList:{

      },
      CounselorIntroduce:{
        aaa:1,

      },
      IsCanAppoint: 0,
      drawer: false,//个人信息抽屉控制
      drawerQuestionnaire: false,//家庭信息抽屉控制
      drawerFamily: false,//咨询问卷抽屉控制
      drawerConsultant: false,//咨询师预约抽屉控制
      form: {//咨询列表筛选参数
        UserID:(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))?this.Global.userID:'',
        AppointmentID:'',
        SASResult:'',
        SDSResult:'',
        ConsultType: '',
        Counselor: '',
        Campus: '',
        ScheduleDate: '',
      },
      selDate:'',
      submitConsult: {//提交咨询参数
        UserID:(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))?this.Global.userID:'',
        AppointmentID:'',
        SASResult:'',
        SDSResult:"",
        SASPaperResultID:"",
        SDSPaperResultID:"",
        ConsultSchID: '',
        Source:sessionStorage.getItem('RoleID').search("1063") != -1?1:sessionStorage.getItem('RoleID').search("1057") != -1 ? 2:'',
        ConsultType:'',
      },
      form2: {
        RealName:'',
        UserID:'',
        Sex:'男',
        Birthday:'',
        Phone:'',
        IDCard:'',
        MarriageState:'已婚',
        Email:'',
        NativePlace:'',
        Nation:'',
        Address:'',
        ReligiousBelief: '',
      },
      form3: {
        date:'',
        time:'',
        type:'远程咨询',
        address:'',
        a5:'',
        a6:'',
        a7:'已婚',
        a8:'',
        a9:'',
        a10:'',
        a11:'',
        a12: '',
      },
      value29: [],
      value25: [],
      value16: [],
      // subject:["183", "184", '186', '188'],
      subject:[],
      drugs:[],
      CounselorList:[],
      Days:7,
      DayInfo:[],
      WeekInfo:[],
      DetailData: {
        ConsultSchID:"",
        UserID:"",
        TesterID:this.Global.userID,
      },
      VsitorNameList:[],
      selConsultType:'',
      selConsultTypeAdmin:'',
      indexval2: [],
      indexval: [],
      value7:[],
      submitConsultCount:0,
      myConsultInfo:{

      },
      // SchedulDays:"",
      // ConsultStartTime:"",
    };
  },
  mounted() {
    // this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
    //   if (res.Code == 200 || res.Code == 0) {
    //     this.data = res.Data;
    //     this.data2 = res.Data;
    //     this.data3 = res.Data;
    //   }
    // })
    // this.$Http_Post('/User/GetDictionaryList', { DicTypCode: "39" }).then((res) => {
    //   if (res.Code == 0) {
    //     this.SchedulDays = res.Data[0].cDicValue;
    //   }
    // })

    // this.$Http_Post('/User/GetDictionaryList', { DicTypCode: "42" }).then((res) => {
    //   if (res.Code == 0) {
    //     this.ConsultStartTime = res.Data[0].cDicValue;
    //     const date = new Date();
    //     date.setTime(date.getTime() + 3600 * 1000 *  (parseInt(res.Data[0].cDicValue)-24));
    //     this.selDate = date;
    //   }
    // })


    // this.selDate = new Date();
    // this.selDate = Date.now() + 3600 * 1000 * (this.ConsultStartTime + 24) //这个返回的是时间戳

    this.$Http_Post('/User/GetConsultInfo').then((res) => {
      if (res.Code == 0) {
        this.myConsultInfo = res.Data;
      }
    })

    this.RoleID = JSON.parse(sessionStorage.getItem('xinxi')).RoleID;
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "24" }).then((res) => {
      if (res.Code == 0) {
        this.indexval = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: "22" }).then((res) => {
      if (res.Code == 0) {
        this.indexval2 = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 13 }).then((res) => {
      if (res.Code == 0) {
        this.value7 = res.Data
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 29 }).then((res) => {
      if (res.Code == 0) {
        this.value29 = res.Data;
      }
    });
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 25 }).then((res) => {
      if (res.Code == 0) {
        this.value25 = res.Data;
      }
    });
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 0) {
        // console.warn(res.Data)
        this.value16 = res.Data;
      }
    });
    if(this.Global.pdroleid(1058)||this.Global.pdroleid(1075)){
      this.GetConsultTotal(this.Global.userID);
    }

    this.$Http_Post('ConsultAppoint/GetCounselorInfoList', { pageIndex: 1,pageSize:6 }).then((res) => {
      if (res.Code == 0) {
        this.CounselorInfoList = res.Data;
        // console.warn(this.CounselorInfoList)
        // console.warn(res.Data[0].UserID);
        // console.warn(res.Data.length);
        // for (let i=0;i++;i<res.Data.length){
        //   this.$set(this.CounselorIntroduce, res.Data[i].UserID, res.Data[i].IndividualResume);
        //   console.warn(res.Data[i]);
        // }
        // console.warn(this.CounselorIntroduce)
      }
    });

    this.$Http_Post('/ConsultAppoint/GetCounselorInfoList',{pageIndex:0,pageSize:999}).then((res) => {
      if (res.Code == 0) {
        this.CounselorList = res.Data;
        this.Days = res.Data.Days;
      }
    });
    if(this.Global.pdroleid(1058)||this.Global.pdroleid(1075)){
      setTimeout(()=> {
        this.getSchedul();// 需要执行的代码
      }, 500);
    }else {
      this.form.AppointmentID = "0";
      this.form.SASResult = "0";
      this.form.SDSResult = "0";

      this.submitConsult.AppointmentID = "0";
      this.submitConsult.SASResult = "0";
      this.submitConsult.SDSResult = "0";
      this.submitConsult.SASPaperResultID = "0";
      this.submitConsult.SDSPaperResultID = "0";

    }
    this.selectTime();

  },
  methods: {
    test(){
      console.warn(this.subject)
    },
    async GetConsultTotal(userId){
      // debugger;
      const res = await this.$Http_Post("ConsultAppoint/GetConsultHome",
              { UserID : userId, AppointmentID:"",pwdtype:'1' });
      //获取咨询评估首页数据
      if (res.Code == 0) {
        var alldata = JSON.parse(this.Global.decrypt(res.Data))
        this.BasicInfo = alldata.BasicInfo;
        this.BasicInfo.AppointmentID = alldata.ConsultInfo.AppointmentID;
        this.ConsultInfo = alldata.ConsultInfo;
        if((this.Global.pdroleid(1058)||this.Global.pdroleid(1075))){
          this.form.AppointmentID = alldata.ConsultInfo.AppointmentID;
          this.form.SASResult = alldata.ConsultInfo.SASResult;
          this.form.SDSResult = alldata.ConsultInfo.SDSResult;
          this.submitConsult.AppointmentID = alldata.ConsultInfo.AppointmentID;
          this.submitConsult.SASResult = alldata.ConsultInfo.SASResult;
          this.submitConsult.SDSResult = alldata.ConsultInfo.SDSResult;
          this.submitConsult.SASPaperResultID = alldata.ConsultInfo.SASPaperResultID;
          this.submitConsult.SDSPaperResultID = alldata.ConsultInfo.SDSPaperResultID;
        }
        if(alldata.ConsultInfo.ConsultTheme != ""){
          this.subject =alldata.ConsultInfo.ConsultTheme.split(",");
        }
        if(alldata.ConsultInfo.PsychotropicDrug != "") {
          this.drugs = alldata.ConsultInfo.PsychotropicDrug.split(",");
        }

        this.IsCanAppoint = alldata.IsCanAppoint;
      }
    },
    fillInformation(){
      // 请先完善个人信息
      if(!this.BasicInfo.EmergencyName || this.BasicInfo.EmergencyName === "" || !this.BasicInfo.EmergencyPhone || this.BasicInfo.EmergencyPhone === "" || !this.BasicInfo.EmergencyRelation.cDicValue || this.BasicInfo.EmergencyRelation.cDicValue === ""){
        this.$confirm('紧急联系人信息未填写，请在右上角个人中心-用户管理里面完善！')
      }else {
        this.drawer = true
        // this.$confirm('紧急联系人信息未填写，请在右上角个人中心-用户管理里面完善！')
      }
    },
    selectTime() {
      // console.warn("1111111111")
      // const days = this.SchedulDays;
      // console.warn(this.SchedulDays+"1111")
      this.pickerOptions = {
        // disabledDate : (time) => time.getTime() < Date.now() + 3600 * 1000 * (this.ConsultStartTime -48) || time.getTime() > Date.now() + 3600 * 1000 * this.ConsultStartTime + 3600 * 1000 * 24 * (this.SchedulDays-2),
        disabledDate : (time) => time.getTime() < new Date(this.WeekInfo[0].Day) - 3600 * 1000 * 24 || time.getTime() > new Date(this.WeekInfo[this.WeekInfo.length - 1].Day),
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '后天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
            picker.$emit('pick', date);
          }
        }]
      }
    },
    async selectVsitorName() {
      // for (let index = 0; index < this.VsitorNameList.length; index++) {
      //   if (this.VsitorNameList[index].UserID == this.form.UserID) {
      //     this.form.UserID = this.VsitorNameList[index].UserID;
      //     this.submitConsult.UserID = this.VsitorNameList[index].UserID;
      //   }
      // }
      this.submitConsult.UserID = this.form.UserID;
      this.GetConsultTotal(this.form.UserID)
      // setTimeout(()=> {
        this.getSchedul();// 需要执行的代码
      // }, 500);
    },
    getVsitorNameList(keyword) {
      if (keyword !== '') {
        this.$Http_Post('ConsultSubscribe/GetStudentList', {
          Keyword: keyword,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    toMyConsult(){
      this.$router.push('/CounselorLeave/ConsultRecord')
    },
    consultSubmit(){
      if(!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))){
        this.submitConsult.ConsultType = this.selConsultTypeAdmin;
      }else {
        this.submitConsult.ConsultType = this.selConsultType;
      }
      if (this.submitConsultCount == 0){
        this.submitConsultCount = 1;
        this.$Http_Post('ConsultAppoint/SubmitConsultAPP',this.submitConsult).then((res) => {
          if (res.Code == 0) {
            this.drawerConsultant = false;
            this.Global.request_successful(res.Message);
            setTimeout(()=> {
              this.$Http_Post('ConsultAppoint/GetSchedulListAPP',this.form).then((res) => {
                if (res.Code == 0) {
                  this.DayInfo = [];
                  this.DayInfo = res.Data.DayInfo;
                  this.WeekInfo = [];
                  this.WeekInfo = res.Data.WeekInfo;
                  // this.selDate = new Date(res.Data.WeekInfo[0].Day);
                  this.submitConsultCount = 0;
                }
              });
            }, 500);
          }else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    async getSchedul(){
      if(this.form.UserID=='' && !(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))) {
        this.Global.request_failure("必须选择学生，才能预约！");
      }else if(!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075)) || (this.BasicInfo.BasicAnswerStatus == 1 && this.ConsultInfo.ConsultAnswerStatus == 1 && this.ConsultInfo.SASResult != '' && this.ConsultInfo.SDSResult != '')) {
        if(this.selDate != ""){
          // console.warn(this.selDate)
          this.form.ScheduleDate = this.Global.formatDate(this.selDate,"YYYY-MM-DD");

        }
         const res = await this.$Http_Post('ConsultAppoint/GetSchedulListAPP',this.form);
        if (res.Code == 0) {
          this.DayInfo = [];
          this.radio3 = 0;
          this.DayInfo = res.Data.DayInfo;
          this.WeekInfo = [];
          this.WeekInfo = res.Data.WeekInfo;
          if(this.selDate == "") {
            this.selDate = new Date(res.Data.WeekInfo[0].Day)
          }
          // console.warn(res.Data.DayInfo)
        }
      }
      // if (this.RoleID == 1058){
      //   this.form.UserID == this.Global.userID;
      //   console.warn(this.form);
      //   console.warn(this.Global.userID);
      // }else {
      //   this.form.AppointmentID = "0";
      //   this.form.SASResult = "0";
      //   this.form.SDSResult = "0";
      // }
    },
    reset(){
      if(!(this.Global.pdroleid(1058)||this.Global.pdroleid(1075))){
        this.form.UserID = '';
      }
      this.form.ConsultType = '';
      this.form.Counselor = '';
      this.form.Campus = '';
      this.form.ScheduleDate = '';
      this.selDate = '';
      this.DayInfo = [];
      // const date = new Date();
      // date.setTime(date.getTime() + 3600 * 1000 * 24);
      // this.selDate = date;
      // const date = new Date();
      // date.setTime(date.getTime());
      // this.selDate = new Date();
    },
    evaluationScale(paperID) {
      this.$router.push({
        path: '/measurement/PaperTest',
        query: { PaperID: paperID, PublishID: 0,type: 4 },
      })
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {

      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
    getConsultantInfo(item){
      if(this.IsCanAppoint == 0){
        this.Global.request_failure("需填写上方资料并进行SAS和SDS测评，且当前没有预约或候补，才可再次预约或候补！");
      }else {
        this.drawerConsultant = true;
        this.DetailData.ConsultSchID = item.ConsultSchID;
        this.submitConsult.ConsultSchID = item.ConsultSchID;
        this.DetailData.UserID = item.UserID;
        this.SelConsultant = item;
        this.SelConsultant.ConsultType0 = item.ConsultType.includes(0);
        this.SelConsultant.ConsultType1 = item.ConsultType.includes(1);
        this.SelConsultant.StartTime = item.StartTime.substring(0,5);
        this.SelConsultant.FinishTime = item.FinishTime.substring(0,5);
        this.selConsultType = item.ConsultType.includes('0') && item.ConsultType.includes('1') ? this.ConsultInfo.ConsultType : item.ConsultType;
        this.selConsultTypeAdmin = item.ConsultType.includes('0') && item.ConsultType.includes('1') ? this.form.ConsultType : item.ConsultType;
        // console.warn(item.ConsultType);
        // console.warn(item.ConsultType.includes(1));
        // console.warn(item.StartTime.substring(0,5))
        // this.SelConsultant.ConsultType0 = item.ConsultType.toString().includes('0');
        this.$Http_Post("ConsultAppoint/GetSchedulDetailAPP",
                this.DetailData
        ).then((res) => {//获取咨询评估首页数据
          if (res.Code == 0) {
            this.Consultant = res.Data;
          }
        });
      }
    },
    getFamily(){
    this.drawer = false;
    this.drawerFamily = true;
    },
    submitBasicInfo() {
      this.BasicInfo.UserID = this.Global.userID;
      if(this.BasicInfo.MentalHistory == 4 && this.BasicInfo.MentalHistoryDetail == ''){
        this.Global.request_failure("请填写家庭成员其他精神障碍明细内容！");
      } else if(this.BasicInfo.OnlySon == 0 && this.BasicInfo.BirthOrder == ''){
        this.Global.request_failure("请填写兄弟排行！");
      } else{
        this.$Http_Post("ConsultAppoint/SubmitBasicInfo",
                this.BasicInfo
        ).then((res) => {//获取咨询评估首页数据
          if (res.Code == 0) {
            this.drawerFamily = false;
            this.Global.request_successful(res.Message);
            setTimeout(function() {
              location.reload();// 需要执行的代码
            }, 500);
          }else {
            this.Global.request_failure(res.Message);
          }
        });

      }
    },
    submitConsultInfo() {
      if(this.subject.indexOf('198')>0 && this.ConsultInfo.OtherConsultTheme == '') {
        this.Global.request_failure("请填写其他咨询主题！");
      }else {
        this.ConsultInfo.ConsultTheme = this.subject.join();
        this.ConsultInfo.PsychotropicDrug = this.drugs.join();
        this.ConsultInfo.UserID = this.Global.userID;
        this.$Http_Post("ConsultAppoint/SubmitConsultInfo",
                this.ConsultInfo
        ).then((res) => {//获取咨询评估首页数据
          if (res.Code == 0) {
            this.drawerQuestionnaire = false;
            this.Global.request_successful(res.Message);
            setTimeout(function() {
              location.reload();// 需要执行的代码
            }, 500);
          }else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.ConsentFormVisible = true;

    },
    no_look() {//不再显示
      this.dialogVisible = false;
      this.ConsentFormVisible = true;
      localStorage.setItem('Conversation', "1");
      localStorage.setItem('ConsentForm', "1");
    },
    acceptForm() {//同意
      if (this.checked == true){
        this.ConsentFormVisible = false;
        localStorage.setItem('ConsentForm', "0");
      }else {
        this.Global.request_failure("您未勾选知情同意书！");
      }
    },
    gotoAddSchList() {
      this.$router.push('/CounselorLeave/ConsultingAppointAdd');
    },
  },
};
</script>
<style>
.Consultation_appointment{
  width: 100%;
  background-color: rgba(242, 242, 242, 1);
  padding-bottom: 15px;
  min-width:1180px;
}
.Consultation_appointment .el-step__title{color: #000;}
.Consultation_appointment .el-step__description{color: #777;}
.Consultation_appointment_top {}

.Consultation_appointment_top .grid-content{
  background-color: #fff;
  height: 150px;
  position: relative;
  border-radius: 5px;
}

.Consultation_appointment_top .grid-content h2{font-size: 18px;margin-left: 20px;padding-top: 10px;}
.Consultation_appointment_top .grid-content h2 info {
  color: #00a0e9;
  background-color: #ebf4ff;
  border-radius: 6px;
  font-size: 18px;
  /*font-weight: normal;*/
  padding: 3px 6px;
  margin-left: 12px;
  margin-top: 10px;
}
.Consultation_appointment_top .grid-content img{height: 70px;width: 70px;position: absolute;top: 60px;left: 20px;}
.Consultation_appointment_top .grid-content h6{position: absolute;top: 65px;left: 110px;font-size: 16px;font-weight: 400;}
.Consultation_appointment_top .grid-content span{position: absolute;top: 90px;left: 110px;font-size: 14px;font-weight: 400;color: #6d6c6c;}
.Consultation_appointment_top .grid-content div{position: absolute;top: 80px;right: 20px;font-size: 14px;font-weight: 400;color: #fff;background-color: rgba(0, 136, 255, 1);padding: 5px 20px;cursor:pointer;border-radius: 3px;}

/*.Consultation_appointment_buttom {height: calc(100% - 170px);}*/
.Consultation_appointment_buttom {
  display: block;
  height: 100%;
}


.Consultation_appointment_buttom .grid-content{background-color: #fff;margin-top: 20px;height: 100%;}

.Consultation_appointment_buttom .noContent{
  font-size: 18px;
  color: #999;
  text-align: center;
  background-color: #fff;
  padding: 175px 30px;
  margin-top: 20px;
  height: 100%;
}

.Consultation_appointment_buttom .el-col{
  height: 100%;
}
.form1 .el-form-item__label{width: 84px !important;margin-left: 12px;text-align: left;}
.form1 .el-select{width: 80%;}
.Consultation_appointment .form1 .el-date-editor.el-input, .el-date-editor.el-input__inner{width: 80%;}
.form1 .obtain{
  padding-bottom: 15px;
  border-bottom: 1px dashed #d3d3d3;
  text-align: right;
  margin-bottom: 12px;
}
.zxslist{ display:flex; margin:0 auto; justify-content:flex-start; flex-flow:wrap; }
.zxslist>li{height: 166px;flex: 1;min-width:360px;max-width:48%;margin-left: 1%;float: left;margin-top: 20px;border-radius: 5px;border: #d3d3d3 1px solid;position: relative;}
.zxslist>li img{width: 95px;height: 95px;position: absolute;top: 20px;left: 20px;border-radius: 50%;}
.zxslist>li h3{position: absolute;left: 140px;top: 20px;font-size: 18px;}
.zxslist>li .zxslist_p{background-color: #eee;color: #999;width: 70px;padding: 4px 0px;text-align: center;border-radius: 3px;position: absolute;left: 140px;top: 125px;}
.zxslist>li .myConsult{
  color: #fff;
  background-color: rgba(0, 136, 255, 1);
  width: 70px;
  padding: 4px 0px;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  left: 140px;
  top: 125px;
}
.zxslist>li ul{position: absolute;top: 60px;left: 130px;}
.zxslist>li ul li{ margin-left: 10px;float: left;border-radius: 3px;padding: 0px 4px;text-align: center;}
.zxslist>li i{font-size: 20px;position: absolute; top: 92px;left: 140px;color: rgba(132, 132, 132, 1);}
.zxslist>li>span{position: absolute; top: 92px;left: 166px;color: rgba(132, 132, 132, 1);}
.zxslist>li>.zxslist_p2{position: absolute;top: 120px;width: 92%;height: 70px; margin-left: 4%;overflow: auto;}
.zxslist>li>.zxslist_p2::-webkit-scrollbar {width: 0px;}
.zxslist>li>.zxslist_p2::-webkit-scrollbar-thumb {display: none;}
.Consultation_appointment .Personal_info h4{margin-top: 20px;margin-left: 20px;font-size: 20px;}
.Consultation_appointment .Personal_info h5{margin-top: 20px;margin-left: 20px;font-size: 16px;font-weight: 600;}
.Consultation_appointment .form2{margin-left: 20px;margin-right: 12px;padding-top: 20px;}
.Consultation_appointment .form2 .el-input{width: 80%;}
.Consultation_appointment .form2 .el-select{width: 80%;}
.Consultation_appointment .form2 .el-select .el-input{width: 100%;}


.Consultation_appointment .form2 .el-cascader{width: 100%;}
/*.Consultation_appointment .form2 .el-select{width: 100%;}*/
.Consultation_appointment_buttom .bg-purple {
  display: block;
  padding-bottom: 15px;
  border-radius: 5px;
  height: 100%;
  padding-right: 15px;
}
.consultantIntroduction {
  width: 92%;
  margin-left: 4%;
}

.consultantIntroduction img{
  width: 95px;
  height: 95px;
  border-radius: 50%;
  float: left;
  margin-right: 12px;
}
.consultantIntroduction h3{
  font-size: 18px;
  margin-top: 12px;
  margin-bottom: 20px;
}
.consultantIntroduction .rank{
  font-size: 12px;
  font-weight:normal;
  background-color: rgba(0, 136, 255, 1);
  color: #fff;
  width: 70px;
  padding: 4px 10px;
  margin-left: 12px;
  border-radius: 3px;
}

.consultantIntroduction i{
  font-size: 20px;
  color: rgba(132, 132, 132, 1);
}
.consultantIntroduction .position{
  color: rgba(132, 132, 132, 1);
}
.consultantIntroduction .introduction{
  width: 100%;
  padding-top: 12px;
  padding-bottom: 30px;
  line-height: 150%;
  overflow: auto;
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 12px;
}
.appointmentSubmission .el-form-item {
  margin-bottom: 0px;
}
.appointmentSubmission h4{
  margin-top: 20px;
  margin-left: 20px;
  font-size: 20px;
}
.appointmentSubmission h5{
  margin-top: 20px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.appointmentSubmission .attention{
  padding-left: 15px;
  size: 13px;
  color: #999;
  line-height: 18px;
}
.form3 .el-form-item__label{
  width: 94px !important;
  padding-left: 22px;
  text-align: left;
}
.formButton{
  margin-top: 50px;
  padding-top: 10px;
  border-top: 1px solid #d3d3d3;
  padding-bottom: 30px;
}
.blockDate{
  padding-left: 12px;
}
.blockDate .date{
  color: #666;
}
.blockDate .myradio .el-radio__inner {
  display: none;
  margin: 0;
}
.blockDate .myradio {
  margin-top: 15px;
  margin-right: 15px;
  margin-left: 0px;
}
.blockDate .el-radio.is-bordered+.el-radio.is-bordered {
  margin-left: 0px;
}
.blockDate .el-radio__label {
  padding: 0px;

}
.blockDate .el-radio__input.is-checked+.el-radio__label {
  color: #fff;
}
.blockDate .is-checked {
  background-color: #0088ff;
  border: 1px solid #0088ff;
  color: #fff;
}

.family_info .familyTitle {
  font-size:14px;
  font-weight:normal;
  margin-left: 2px !important;
  padding-bottom: 15px;
}
.family_info .el-radio {
  display: block;
  padding-bottom: 12px;
}

.family_info .oneLine .el-radio {
  display: inline-block;
  padding-top: 12px;
}
.family_info .oneLine2 .el-radio {
  display: inline-block;
  padding-top: 0px;
}
.form4 .el-form-item__label{
  width: 100px !important;
}
.Consultation_appointment_top .grid-content2{
  background-color: #fff;
  height: 150px;
  position: relative;
  border-radius: 5px;
}

.Consultation_appointment_top .grid-content2 h2{
  font-size: 18px;
  margin-left: 20px;
  padding-top: 10px;
}
.Consultation_appointment_top .grid-content2 img{
  height: 70px;
  width: 70px;
  position: absolute;
  top: 60px;
  left: 20px;
}
.Consultation_appointment_top .grid-content2 .evaluation{
  position: absolute;
  top: 50px;
  left: 110px;
  width: calc(100% - 130px);
}
 .Consultation_appointment_top .grid-content2 .evaluation .questionnaire{
   display: flex;
   Justify-content:space-between;
   cursor:pointer;
 }
.Consultation_appointment_top .grid-content2 .evaluation .questionnaire .describe{
  display: flex;
  flex-direction: column;
  Justify-content:space-around;
  cursor:pointer;
}

.Consultation_appointment_top .grid-content2 h6{
  font-size: 16px;
  font-weight: 400;
}
.Consultation_appointment_top .grid-content2 span{
  font-size: 14px;
  font-weight: 400;
  color: #6d6c6c;
}
.Consultation_appointment_top .grid-content2 .button{
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background-color: rgba(0, 136, 255, 1);
  padding: 5px 20px;
  margin: 10px 0px;
  cursor:pointer;
  border-radius: 3px;
}

.Consultation_appointment_top .grid-content2 .score{
  font-size: 21px;
  font-weight: 600;
  color: rgba(242, 75, 78, 1);
  padding: 0px 20px;
  margin: 10px 0px;
}

.radioStyle{
  margin-bottom: 10px ;
}
.consentForm{
  font-size: 16px;
  line-height: 180%;
  padding: 10px 2%;
}
.consentFormDialog .el-dialog__header {
  text-align: center;
}
.consentFormDialog .el-dialog__body {
  padding: 0px 0px !important;
}
.agreeInfoBox {
  padding: 10px 20px !important;
  background-color: #f6f6f6;
}
.agreeInfoBox .buttonBox {
  padding-top: 8px;
  text-align: center;
}
.agreeInfoBox .agreeInfo {
  padding-left: 15px;
  line-height: 150%;
}
.train{
  border-bottom: 1px dashed #ddd;
  padding: 0px 0px 12px 12px;
  margin-bottom: 10px;
}
.trainFont{
  font-size: 14px;
  color: #999;
  padding-top: 8px;
}


</style>
